import * as React from 'react';
import { useForm } from "react-hook-form";
import type { SubmitHandler } from "react-hook-form";

import Button from '../Button/Button';
import SubmitButton from '../SubmitButton/SubmitButton';

import type { Entity } from '../../types/Entity';

type Input = {
    name: string;
    amount: string;
};

type AssetRowProps = {
    asset: Entity, 
    index: number, 
    remove: (index: number) => void
};

function AssetRow({asset, index, remove}: AssetRowProps) {
    const [view, setView] = React.useState<boolean>(false);
    const [edit, setEdit] = React.useState<boolean>(false);

    const {
        register,
        handleSubmit,
    } = useForm<Input>();

    const onSubmit: SubmitHandler<Input> = (data: Input) => {
        asset.name = data.name;
        asset.amount = parseFloat(data.amount);
        setEdit(false);
    }

    return (
        <div>
            <p>{asset.name}</p>
            <Button callback={() => { setView(true) }}>View</Button>
            <Button callback={() => { setEdit(true) }}>Edit</Button>
            <Button callback={() => { remove(index) }}>Delete</Button>
            {view && (
                <div>
                    <p><span>Name:</span> <span>{asset.name}</span></p>
                    <p><span>Amount:</span> <span>{asset.amount}</span></p>
                    <Button callback={() => { setView(false) }}>Close</Button>
                </div>
            )}
            {edit && (
                <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <label htmlFor="name">Name</label>
                        <input id="name" defaultValue={asset.name} {...register("name")} />

                        <label htmlFor="name">Amount</label>
                        <input id="amount" type="number" min={0} step={0.01} defaultValue={asset.amount} {...register("amount")} />

                        <Button callback={() => { setEdit(false) }}>Cancel</Button>
                        <SubmitButton>Update</SubmitButton>
                    </form>
                </div>
            )}
        </div>
    );
}


export default AssetRow;
